import { useGetUsersQuery } from "./usersApiSlice"
import { Link } from "react-router-dom";

const UsersList = () => {
    const {
        data: users,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUsersQuery()

    let content;
    if (isLoading) {
        content = <p>"Loading..."</p>;
    } else if (isSuccess) {
        content = (
            <div className="container-fluid px-4 mt-4">
                <section className="users">
                    <h1>Users List</h1>
                    <ul>
                        {users.map((user, i) => {
                            return <li key={i}>{user.displayName}</li>
                        })}
                    </ul>
                    <Link to="/welcome">Back to Welcome</Link>
                </section>
            </div>
        )
    } else if (isError) {
        content = <p>{JSON.stringify(error)}</p>;
    }

    return content
}
export default UsersList